import React from 'react';
import { Typography, type TypographyProps } from '@mui/material';
import { splitSystemProps, type SystemShorthandProps } from '../systemProps';

export type TextProps = TypographyProps & SystemShorthandProps;

export default function Text({ children, className, sx, ...props }: TextProps) {
  const split = splitSystemProps(props, sx, { paletteColorProp: true });
  return (
    <Typography className={className} {...split.rest} sx={split.sx}>
      {children}
    </Typography>
  );
}
